import L from 'leaflet';
import { formatCoordinate } from '../util/geoUtils';

export function initCoordsPanel(map: L.Map) {
    // 1. Inject HTML for Panel
    const panelHtml = `
<div id="coords-panel" style="display:none;">
    <h3>Current Position</h3>
    <div style="border:1px solid #333; border-radius:8px; padding:1em;">
        <div style="margin-bottom: 1em; display: flex; flex-wrap: wrap; gap: 1em;">
            <label><input type="radio" name="coord-format" value="deg-min" checked> Degrees Minutes</label>
            <label><input type="radio" name="coord-format" value="deg-dec"> Degrees Decimal</label>
        </div>
        <div style="margin-bottom: 1em;">
            <label><input type="checkbox" id="crosshairs-checkbox" checked> Cross-hairs</label>
        </div>
        <div>
            <label for="coords-display">Coordinates:</label>
            <input type="text" id="coords-display" readonly style="width: 95%; padding: 0.5em; margin-top: 0.5em; box-sizing: border-box;" />
            <p style="font-size: 0.8em; color: #666; margin-top: 0.5em;">Center of the map view.</p>
            <div style="margin-top: 1em;">
                <label for="opacity-slider">Fader :</label>
                <input type="range" id="opacity-slider" min="10" max="100" value="50" style="vertical-align: middle;">
            </div>
        </div>
    </div>
    <div style="margin-top:1em;">
        <button id="close-coords-btn">Close</button>
    </div>
</div>
    `;

    const appContainer = document.getElementById('app');
    if (appContainer) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = panelHtml;
        appContainer.appendChild(tempDiv.firstElementChild!);
    }

    // 2. Inject HTML for Cross-hairs
    const crosshairsHtml = `<div id="map-crosshairs"></div>`;
    const crosshairsDiv = document.createElement('div');
    crosshairsDiv.innerHTML = crosshairsHtml;
    document.body.appendChild(crosshairsDiv.firstElementChild!);

    // 3. Get References
    const coordsPanel = document.getElementById('coords-panel')!;
    const closeBtn = document.getElementById('close-coords-btn')!;
    const displayInput = document.getElementById('coords-display') as HTMLInputElement;
    const formatRadios = document.querySelectorAll('input[name="coord-format"]');
    const crosshairsCheckbox = document.getElementById('crosshairs-checkbox') as HTMLInputElement;
    const crosshairsElement = document.getElementById('map-crosshairs')!;
    const opacitySlider = document.getElementById('opacity-slider') as HTMLInputElement;

    let currentFormat: 'deg-min' | 'deg-dec' = 'deg-min';

    // Set default opacity
    coordsPanel.style.opacity = '0.5';

    // 4. Helper Functions
    function updateDisplay() {
        const center = map.getCenter();
        let text = '';

        if (currentFormat === 'deg-dec') {
            text = `${center.lat.toFixed(6)}, ${center.lng.toFixed(6)}`;
        } else {
            const latStr = formatCoordinate(center.lat, true, 'deg-min');
            const lngStr = formatCoordinate(center.lng, false, 'deg-min');
            text = `${latStr}  ${lngStr}`;
        }
        
        displayInput.value = text;
    }

    function openPanel() {
        updateDisplay();
        coordsPanel.style.display = 'block';
    }

    // 5. Attach Listeners
    map.getContainer().addEventListener('open-coords-panel', () => {
        if (coordsPanel.style.display === 'block') {
            coordsPanel.style.display = 'none';
        } else {
            // Close other panels before opening this one
            map.getContainer().dispatchEvent(new CustomEvent('close-other-panels', { detail: 'coords-panel' }));
            openPanel();
        }
    });

    // Listen for close request from other panels
    map.getContainer().addEventListener('close-other-panels', (e: any) => {
        if (e.detail !== 'coords-panel') {
            coordsPanel.style.display = 'none';
        }
    });

    closeBtn.addEventListener('click', () => {
        coordsPanel.style.display = 'none';
    });

    formatRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            currentFormat = (e.target as HTMLInputElement).value as 'deg-min' | 'deg-dec';
            updateDisplay();
        });
    });

    crosshairsCheckbox.addEventListener('change', () => {
        crosshairsElement.style.display = crosshairsCheckbox.checked ? 'block' : 'none';
    });

    opacitySlider.addEventListener('input', () => {
        const opacity = parseInt(opacitySlider.value) / 100;
        coordsPanel.style.opacity = opacity.toString();
    });

    // Initial sync (though CSS handles the default 'block', this ensures JS state matches)
    crosshairsElement.style.display = crosshairsCheckbox.checked ? 'block' : 'none';

    // Update coordinates when map moves, but only if panel is visible
    map.on('move', () => {
        if (coordsPanel.style.display !== 'none') {
            updateDisplay();
        }
    });
}
